<template>
  <div>
    <loginheader></loginheader>
    <div class="replace2-con">
      <p class="replace2-con-p">更换手机</p>
      <input type="text" class="replace2-con-input" placeholder="请输入手机号" v-model="phoneNum" />
      <div class="replace2-con-div">
        <input type="text" class="replace2-con-div-left" placeholder="请输入验证码" v-model="captcha" />
        <button type="button" class="replace2-con-btn" @click="getCode">
          <span v-show="show">获取验证码</span>
          <span v-show="!show" class="count">重新获取{{count}} s</span>
        </button>
      </div>
      <router-link to>
        <button type="button" class="replace2-btn" @click="surechange">确&nbsp;认&nbsp;修&nbsp;改</button>
      </router-link>
      <p class="replace2-tishi" v-if="ckcaptcha">* 验证码错误</p>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
import loginheader from "../loginheader.vue";
import Fotter from "../Fotter.vue";
export default {
  name: "App",
  props: ["flag"],
  components: {
    loginheader,
    Fotter
  },
  data() {
    return {
      show: true,
      count: "",
      timer: null,
      ckcaptcha: false,
      phoneNum: "",
      captcha: ""
    };
  },
  methods: {
    getCode() {
      if (this.show) {
        this.$http
          .post("sms/send", {
            mobile: this.phoneNum,
            event: "cmone"
          })
          .then(res => {
            if (res.body.code == 0) {
              this.ckphone = true;
            }
            if (res.body.code == 1) {
              this.ckphone = false;
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000);
              }
            }
          });
      }
    },
    surechange() {
      (this.ckphone = false), (this.ckcaptcha = false);
      var ckPhone = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!ckPhone.test(this.phoneNum)) {
        this.ckphone = true;
        return;
      }
      this.$http
        .post("user/cmobile", {
          mobile: this.phoneNum,
          captcha: this.captcha,
          token: this.$cookies.get("token")
        })
        .then(res => {
          if (res.body.code == 1) {
            this.$router.push("/index");
          } else if (res.body.code == 0) {
            this.$notify({
              message: res.body.msg,
              type: "warning"
            });
          }
        });
    }
  }
};
</script>

<style scoped="scoped">
.replace2-con {
  width: 350px;
  margin: 150px auto 250px;
}
.replace2-con-p {
  text-align: center;
  color: #212121;
  font-size: 16px;
}
.replace2-con-input {
  width: 340px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #b4b4b4;
  margin-top: 40px;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;
}
.replace2-con-input1 {
  width: 340px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #b4b4b4;
  margin-top: 20px;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;
}
.replace2-con-div {
  width: 340px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 16px;
}
.replace2-con-div-left {
  width: 190px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #b4b4b4;
  padding-left: 10px;
  box-sizing: border-box;
  font-size: 16px;
}
.replace2-con-btn {
  width: 130px;
  height: 40px;
  border-radius: 6px;
  box-sizing: border-box;
  border: 1px solid #6bccd5;
  font-size: 16px;
  padding-left: 5px;
  color: #6bccd5;
  background-color: #fff;
}
.replace2-btn {
  margin-top: 20px;
  width: 340px;
  height: 40px;
  border-radius: 6px;
  border: 0;
  background-color: #6bccd5;
  color: #fff;
  font-size: 16px;
}
.replace2-tishi {
  margin-top: 10px;
  color: #d10000;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/replace/replace2.vue